module.exports = __webpack_public_path__ + "img/export.5f202431.svg";